import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class popupView_template extends vnTemplate {

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , isEnabled: ko.observable(false)
            , headline: ko.observable("")
            , description: ko.observable("")
            , image: ko.observable(null)
            , signupForm: ko.observable(null)
            , geos: ko.observable("")
            , pageDepth: ko.observable("")
            , onClickEditPopup: function (data, event) {
                self.onClickEditPopup(data.id());
            }
            , onClickCancel: function (data, event) {
                self.onClickCancel();
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`
            <div class="w-form">
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button> 
                    <h3 class="form-title" data-bind="text: headline"></h3>
                    <div class="w-btn">
                         <button data-bind="event: { click: onClickEditPopup }" class="btn icon i-edit"  type="button">Edit Popup</button>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Info</strong>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                             <dl class="double-list">
                                <dt>
                                    <span>Enabled</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: isEnabled"></span>
                                </dd>
                                <dt>
                                    <span>Popup Headline</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: headline"></span>
                                </dd>
                                <dt class="full-width">
                                    <span>Popup Description</span>
                                </dt>
                                <dd class="full-width">
                                    <span data-bind="text: description" style="max-width: 640px;"></span>
                                </dd>                          
                                <dt>
                                    <span>Signup Form</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: signupForm"></span>
                                </dd>
                                <dt>
                                    <span>GEOs</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: geos"></span>
                                </dd>
                                <dt>
                                    <span>Page Depth for Automatic Display</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: pageDepth"></span>
                                </dd>
                                <dt class="full-width">
                                    <span>Popup Image</span>
                                </dt>
                                <dd class="full-width">
                                    <span><img style="max-width: 400px" data-bind="attr: { src: image }, visible: image()"></span>
                                    <span data-bind="text: 'False', visible: !image()"></span>
                                </dd>
                             </dl>
                        </div>
                    </div>
                </div>
            </div>
        `);
    }

    protected setPopupData(popup) {
        this.getTemplateViewModel().id(popup.id)
        this.getTemplateViewModel().isEnabled(popup.isEnabled)
        this.getTemplateViewModel().headline(popup.headline)
        this.getTemplateViewModel().description(popup.description)
        this.getTemplateViewModel().image(popup.image)
        this.getTemplateViewModel().signupForm(popup.signupForm.label)
        if(popup.geos) {
            let geoNames = [];
            popup.geos.forEach(function (element, index) {
                if (index == 0) {
                    geoNames.push(element.name);
                }
                else {
                    geoNames.push(" " + element.name);
                }
            });
            this.getTemplateViewModel().geos(geoNames)
        }
        if(!popup.pageDepth && popup.pageDepth !== 0) {
            this.getTemplateViewModel().pageDepth("Off")
        }
        else {
            this.getTemplateViewModel().pageDepth(popup.pageDepth)
        }
    }

    protected getTemplateName(): string {
        return "popupView_template";
    }

    protected onClickEditPopup(id: any): any {
        this.caller.onClickEditPopup(id)
    }

    protected onClickCancel(): any {
        this.caller.onClickCancel()
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/popupView_template.ts